var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.vmode)?_c('div',{staticClass:"preview"},_vm._l((_vm.jsonView),function(element){return _c(element.type,{key:element.uuid,tag:"component",attrs:{"uuid":element.uuid,"element":element,"mode":true,"pmode":true}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }